import { AddressAddressTypeEnum, AddressDTO } from "@smartx/mikro-vt-client-api"

export const getAddress = (
  addresses: AddressDTO[],
  addressType: AddressAddressTypeEnum,
): string => {
  let address: AddressDTO = null

  address = addresses?.find((addr) => addr.addressType === addressType)

  if (!address) {
    return ""
  }

  const addressParts: string[] = [
    address.postalCode,
    [address.city, address.street].filter((el) => !!el).join(", "),
    address.streetType,
  ]

  if (address.floorDoor) {
    addressParts.push([address.houseNumber, "."].join(""), address.floorDoor)

    return addressParts.filter((el) => !!el).join(" ") || ""
  }

  let houseNumberPart = ""

  if (!!address.houseNumber && !!address.houseNumLetter) {
    houseNumberPart = [address.houseNumber, address.houseNumLetter]
      .filter((el) => !!el)
      .join("/")
  } else if (address.houseNumber) {
    houseNumberPart = [address.houseNumber, "."].join("")
  }

  addressParts.push(
    houseNumberPart,
    address.building,
    address.staircase ? [address.staircase, "lh."].join(" ") : "",
    address.floor ? [address.floor, "em."].join(" ") : "",
    address.flatNumber,
  )

  let formattedAddress = addressParts.filter((el) => !!el).join(" ") || ""
  formattedAddress += address.poBox ? [",", "pf.", address.poBox].join(" ") : ""
  formattedAddress += address.location
    ? [",", "hrsz.", address.location].join(" ")
    : ""

  return formattedAddress
}
